import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, StarIcon } from "lucide-react";
export function AboutSection() {
  return <section className="w-full bg-white py-20 md:py-28" data-id="element-58" data-mp="2y9zwq8e2mw5h">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 md:px-8 lg:grid-cols-2 lg:gap-20" data-id="element-59" data-mp="2tbeuy4j684ex">
        <div className="relative" data-id="element-60" data-mp="2oe6m4ujwxcqc">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/2a3a7530-b37d-4c7b-b344-70f1a46b9f12.jpg" alt="L'équipe de techniciens Hydréa devant leur camionnette" className="h-[420px] w-full rounded-2xl object-cover md:h-[560px]" data-id="element-61" data-mp="2oey595wbphzq" />
          <div className="absolute -bottom-6 right-4 rounded-2xl bg-lime p-6 text-ink md:right-[-24px]" data-id="element-62" data-mp="3c99c55ugdm8e">
            <div className="flex items-center gap-1" aria-hidden="true" data-id="element-63" data-mp="37bpojfbv7x3s">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-ink" data-id="element-64" data-mp="3viv01n5zg8q" data-mpi={i} />)}
            </div>
            <p className="mt-2 text-4xl font-semibold tracking-tight" data-id="element-65" data-mp="1ldqkhhrwk9gx">4,9/5</p>
            <p className="text-sm font-medium" data-id="element-66" data-mp="1lfum1t2bwwe1">312 avis Google</p>
          </div>
        </div>

        <div data-id="element-67" data-mp="1qeo3fwkql7jh">
          <h2 className="text-4xl font-semibold leading-[1.05] tracking-tight text-ink md:text-5xl" data-id="element-68" data-mp="1bnotah496axs">
            Une entreprise familiale, des artisans qui signent leur travail
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-69" data-mp="1gkfax8vphelb">
            Depuis 2001, Hydréa intervient chez les particuliers, syndics et
            commerces de la métropole lyonnaise. Nos 14 techniciens sont salariés,
            formés en continu et équipés pour intervenir proprement, du premier
            coup.
          </p>

          <dl className="mt-10 grid grid-cols-2 gap-x-8 gap-y-8 border-t border-ink/10 pt-10" data-id="element-70" data-mp="xn4dzuxjqx91">
            <div className="col-span-2 sm:col-span-1" data-id="element-71" data-mp="2n2kll5vtoawt">
              <dt className="text-sm text-muted" data-id="element-72" data-mp="2n112l7is7lrc">Chantiers réalisés</dt>
              <dd className="mt-1 text-6xl font-semibold tracking-tightest text-ink" data-id="element-73" data-mp="2s1f2216bhndr">
                3 800+
              </dd>
            </div>
            <div className="grid grid-cols-2 gap-6 sm:col-span-1 sm:grid-cols-1" data-id="element-74" data-mp="2llyd6bg9pgcv">
              <div data-id="element-75" data-mp="2lo1brjvhkht7">
                <dt className="text-sm text-muted" data-id="element-76" data-mp="2gmbxlvcyvo0w">Années d'expérience</dt>
                <dd className="mt-1 text-2xl font-semibold text-ink" data-id="element-77" data-mp="2goezbcnhf5lg">25 ans</dd>
              </div>
              <div data-id="element-78" data-mp="2bpvbt7t8plqz">
                <dt className="text-sm text-muted" data-id="element-79" data-mp="39azp48ob79mw">Zone d'intervention</dt>
                <dd className="mt-1 text-2xl font-semibold text-ink" data-id="element-80" data-mp="39d3s8oedw4m4">Lyon + 30 km</dd>
              </div>
            </div>
          </dl>

          <Link to="/a-propos" className="mt-10 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-ink px-7 py-3.5 font-medium text-white transition-colors duration-150 ease-out hover:bg-ink-soft" data-id="element-81" data-mp="2zky4xrz2ubd9">
            Découvrir l'équipe
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-82" data-mp="3nb0o1il0k6zq" />
          </Link>
        </div>
      </div>
    </section>;
}